import { ApiResponse } from 'apisauce';

import { generateApiClient } from '../api';
import { getGeneralApiProblem } from '../api/api-problem';
import { Address, Customer } from '../../types/customer';

const api = generateApiClient();

export const getCustomersApi = async (query?: any): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.get(`customers${query}`);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;

    return { kind: 'ok', data: data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const createCustomerApi = async (customer: Customer): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.post(`customers`, customer);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const updateCustomerApi = async (id: number, customer: Customer): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.put(`customers/${id}`, customer);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const getCustomerByIdApi = async (id: number): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.get(`customers/${id}`);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const getAddressesByCustomerIdApi = async (id: number, query?: any): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.get(`customers/${id}/addresses${query}`);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const getAddressByIdApi = async (customerId: number, addressId: number): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.get(`customers/${customerId}/addresses/${addressId}`);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const createAddressApi = async (customerId: number, address: Address): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.post(`customers/${customerId}/addresses`, address);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const updateAddressApi = async (customerId: number, addressId: number, address: Address): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.put(`customers/${customerId}/addresses/${addressId}`, address);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};
